module.exports = __webpack_public_path__ + "static/media/marcos-alvarenga.e3a8354d.png";